module.exports = __webpack_public_path__ + "assets/img/out_(6).8c37ec3b.gif";